import { render, staticRenderFns } from "./ObjectsRealtyEdit.vue?vue&type=template&id=3d9751b4&"
import script from "./ObjectsRealtyEdit.vue?vue&type=script&lang=js&"
export * from "./ObjectsRealtyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports